export const Header = (function () {
	"use strict";

	const MOBILE_BREAKPOINT = 768

	let
		$body,
		$sideMenu,
		$menuCatButtons,
		$menuLinks,
		$primaryLinks,
		$menuLinksButton,
		$siteHeader,
		$contentOverlay,
		$activeMenu,
		$activeButton,
		$bannerVideoPauseBtn,
		$mobileSubMenu,
		$categoryMenuLink;

	function init() {
		$body = $("body");
		$bannerVideoPauseBtn = $("#banner-video-icon");
		$sideMenu = $('[data-side-menu]');
		$menuCatButtons = $('[data-href]');
		$menuLinks = $('[data-menu-links]');
		$primaryLinks = $('[data-menu-primary]');
		$menuLinksButton = $('[data-menu-links-button]');
		$siteHeader = $('[data-site-header]');
		$contentOverlay = $('[data-menu-content-overlay]');
		$categoryMenuLink = $('.category-menu-link');
		$mobileSubMenu = $('.mobile-menu-btn');
		events();
	}

	function isSmall() {
		return $body.innerWidth() < MOBILE_BREAKPOINT;
	}

	function closeSidebar(isDone = false) {
		$primaryLinks.removeClass('open');
		if ($activeMenu) {
			$activeMenu.removeClass('open');
			$activeMenu = false;
			$mobileSubMenu.removeClass('open').attr("aria-expanded", "false");

		}
		if (!isSmall() || isDone) {
			$menuLinksButton.removeClass('open').attr("aria-expanded", "false");
		}
		if ($activeButton) {
			$activeButton.removeClass('open');
		}
		if (isDone) {
			$sideMenu.removeClass('open');
			$siteHeader.removeClass('open root');
			$body.removeClass("mobile-menu-open");

			$(window).on('keyup', function (e) {
				if (e.keyCode == 27) {
					$sideMenu.removeClass('open');
					$siteHeader.removeClass('open root');
					$body.removeClass("mobile-menu-open");
				}
			});
		}

		$activeMenu = false;
		$activeButton = false;

		$('.menu-main').attr('aria-labelledby', '');
	}

	function openSidebar() {
		$siteHeader.addClass('open');
		$sideMenu.addClass('open');
		$body.addClass("mobile-menu-open");
		$mobileSubMenu.addClass('open').attr("aria-expanded", "true");
	}

	function openRoot() {
		$siteHeader.addClass('root');
		$sideMenu.addClass('open');
		if (isSmall()) {
			setActiveMenu($('.menu-cat-buttons'));
		} else {
			setActiveMenu($menuLinks);
			$menuLinks.addClass('open');
		}
	}

	function setActiveMenu($el) {
		$activeMenu = $el;
		$el.addClass('open');
		const $inputs = $el.find(`a, button`);
		$inputs.first().focus();
		setTimeout(function () {
			const $inputs = $el.find(`a, button`);
			$inputs.first().focus();
		}, 500);
	}

	function events() {
		// Add class to primary nav for styling
		$('.menu-primary').children('nav').addClass('category-nav');
    
		// Close menu on overlay click
		$contentOverlay.on('click', function () {
			closeSidebar(true);
		});

		trapMenuFocus();

		// Open/close side menu button
		$menuLinksButton.on('click', function () {
			const small = isSmall();
			if (small && $activeMenu) {
				closeSidebar(true);
			} else if ($activeMenu === $menuLinks) {
				closeSidebar(true);
			} else {
				closeSidebar();
				openSidebar();
				openRoot();
			}
			$('.menu-main').attr('aria-labelledby', 'Toggle Menu');
			$('.category-menu-link').attr('aria-expanded', 'false');
		});

		// Mobile submenu toggle
		$mobileSubMenu.on('click', function () {
			const small = isSmall();
			$('.mobile-menu-btn').removeClass('open').attr("aria-expanded", "false");
			if (small && $activeMenu) {
				closeSidebar(true);
			} else if ($activeMenu === $menuLinks) {
				closeSidebar(true);
			} else {
				closeSidebar();
				openSidebar();
				openRoot();
			}
		});

		// Category button clicks
		$menuCatButtons.on('click', function () {
			const $this = $(this);
			const href = $this.attr('data-href');
			const $target = $(`nav[class="category-nav"] .category-menu-link[href="${href}"]`).parent();

			if ($activeMenu && $activeMenu[0] === $target[0]) {
				closeSidebar(true);
			} else {
				closeSidebar();
				openSidebar();
				setActiveMenu($target, href);
				$activeButton = $this;
				$primaryLinks.addClass('open');
				$siteHeader.removeClass('root');
				$this.addClass('open');
			}

			$this.attr('aria-expanded', 'true');
			$('.category-menu-link').not(this).attr('aria-expanded', 'false');
			$('.menu-main').attr('aria-labelledby', 'Toggle Menu');
		});

		// Close menu button
		$('[data-close-menu]').on('click', function () {
			if (isSmall()) {
				closeSidebar();
				openRoot();
				$mobileSubMenu.addClass('open').attr("aria-expanded", "true");
			} else {
				closeSidebar(true);
			}
			$('.category-menu-link').attr('aria-expanded', 'false');
		});

		// Accessibility: trap focus within menu
		trapMenuFocus();

		// ESC key to close menu
		$(window).on("keyup", function (e) {
			if (e.keyCode === 27) { // ESC key
				if ($activeMenu) {
					closeSidebar(true);
					$('.category-menu-link').attr('aria-expanded', 'false');
				}
			}
		});

		// Update aria attributes on category menu link click
		$categoryMenuLink.click(function () {
			const navItemName = $(this).attr('data-title');
			const ariaLabel = 'Close ' + navItemName;

			$(this).attr('aria-expanded', $(this).hasClass('open') ? 'true' : 'false');
			$mobileSubMenu.toggleClass('open', !$(this).hasClass('open')).attr("aria-expanded", !$(this).hasClass('open'));
			$('[data-close-menu]').attr('aria-label', ariaLabel);
		});
	}


	function trapMenuFocus(){
		$(document).on('keydown', function (e) {
			let $currentEl = $(document.activeElement);
			let $focusableEls = $('.menu-main, .menu-cat-buttons, .nav-items').find('a, button, input').add('.mobile-menu-btn');
			let $lastEl = $('.menu-main a').last();
			let $firstEl = $('.mobile-menu-btn');

			if($('.mobile-menu-btn:visible').length > 0){
				$firstEl = $('.mobile-menu-btn');
			} else {
				$firstEl = $('.close-menu-button');
			}

			if(e.keyCode === 9 && !e.shiftKey && $currentEl.is($lastEl)) {
				e.preventDefault();
				$firstEl.focus();
			}

			if(e.keyCode === 9 && e.shiftKey && $currentEl.is($firstEl)){
				e.preventDefault();
				$lastEl.focus();
			}
		});		
	}

	return {
		init: init,
	};
})();

